import { combineReducers } from 'redux';

import signUpReducer from './signUp/signUp.reducer';

const inviteUser = combineReducers({
  signUp: signUpReducer,
});

export default inviteUser;
